import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import { useTranslation } from "react-i18next";

const RiskScoreCurrencySelect = ({ checkedCurrency, setCheckedCurrency, defaultOption = false }) => {
  const { t } = useTranslation("otherInterface");

  const [statuses, setStatuses] = useState([
    "BTC",
    "ETH",
    "BCH",
    "LTC"
  ]);

  return (
    <FormControl>
      <Autocomplete
        options={statuses || []}
        value={checkedCurrency || null}
        onChange={(event, checkedCurrency) => setCheckedCurrency(checkedCurrency)}
        renderInput={(params) => (
          <TextField {...params} label={t("currenciesSelect.title")} />
        )}
        blurOnSelect
        disableClearable={!defaultOption}
      />
    </FormControl>
  );
};

export default RiskScoreCurrencySelect;